module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-How-SHG-works.8c31621d.webp";